import React, { useMemo } from 'react';
import {
  FileUploaderItem,
  useDocumentPreviewModalDeprecated,
} from '@common/components';
import { SimpleFileFragmentType } from '@common/graphql';

export const DisputeFiles = ({
  files,
  onDelete,
  hiddenFiles,
}: {
  files: SimpleFileFragmentType[];
  hiddenFiles?: SimpleFileFragmentType[];
  onDelete?: (file: SimpleFileFragmentType) => void;
}) => {
  const { handleOpen } = useDocumentPreviewModalDeprecated();

  const shownFiles = useMemo(() => {
    if (!hiddenFiles) {
      return files;
    }

    return files.filter((file) => !hiddenFiles.includes(file));
  }, [files, hiddenFiles]);

  return (
    <>
      <div className="DisputeFiles">
        {!shownFiles.length ? (
          <i className="empty">No attached files</i>
        ) : (
          shownFiles.map((file) => (
            <FileUploaderItem
              key={file.id}
              onClick={() =>
                handleOpen({
                  kind: 'url',
                  data: file.downloadUrl || '',
                })
              }
              fileName={file.filename}
              onDelete={() => onDelete?.(file)}
              showDelete={!!onDelete}
            />
          ))
        )}
      </div>
      <style jsx>
        {`
          .DisputeFiles {
            max-width: 100%;
          }
          .DisputeFiles .empty {
            margin-top: 8px;
            display: block;
          }
        `}
      </style>
    </>
  );
};
